export default function initializeTextContainer() {
    document.querySelectorAll('.block-text-container').forEach(function(block) {
        new TextContainer(block);
    });
}

class TextContainer {
    constructor(block) {
        this.block = block;
        this.init();
    }

    async init() {
        const parallaxElement = this.block.querySelector('.block-text-container__parallax');

        if (parallaxElement) {
            await this.loadGSAP();
            this.addParallaxEffect(parallaxElement);
        }
    }

    async loadGSAP() {
        const { gsap } = await import('gsap');
        const { ScrollTrigger } = await import('gsap/ScrollTrigger');
        gsap.registerPlugin(ScrollTrigger);
        this.gsap = gsap;
    }

    addParallaxEffect(parallaxElement) {
        this.gsap.to(parallaxElement, {
            yPercent: -50,
            ease: "none",
            scrollTrigger: {
                trigger: this.block,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            }
        });
    }
}
